import axios from 'axios'
import * as Util from '@/vuex/util'

let startState = []

const state = {
  collision: startState
}

const mutations = {
  FETCH (state, collisionId) {
    axios.get(Util.makeApiUrl('/collisions/' + collisionId)).then(function (response) {
      state.collision = response.data
    }).catch(function (error) {
      console.log(error)
    })
  },

  RESET (state) {
    state.collision = startState
  }
}

const actions = {
  fetch: function ({commit}, collisionId) {
    commit('FETCH', collisionId)
  },

  reset: function ({commit}) {
    commit('RESET')
  }
}

const getters = {
  get: state => state.collision
}

export const Collision = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/vuex/modules/trays/Collision.js